<template>
  <div style="padding: 8px 0">
    <GmapMap
      :center="computedCenter"
      :zoom="15"
      :options="options"
      style="width: 100%; height: 300px"
    >
      <GmapInfoWindow
        :position="infoWindowPos"
        :opened="infoWinOpen"
        :options="infoOptions"
        @closeclick="infoWinOpen = false"
      >
      </GmapInfoWindow>
      <GmapMarker
        v-for="(m, i) in computedRecords"
        :key="i"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        @click="toggleInfoWindow(m, i)"
      />
    </GmapMap>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  name: 'GoogleMap',
  props: {
    records: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: {
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        scrollwheel: true,
        clickableIcons: false,
      },
      infoWindowPos: null,
      infoWinOpen: false,
      currentIdx: null,

      infoOptions: {
        maxWidth: 200,
        content: '',
        pixelOffset: {
          width: 0,
          height: -40,
        },
      },
    }
  },

  // <div style="width:16px;height:16px;">
  //  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 6V12" stroke="#808a87" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16.24 16.24L12 12" stroke="#808a87" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
  // </div>
  computed: {
    computedRecords() {
      if (this.records && this.records.length > 0) {
        return this.records.map(record => {
          return {
            position: { lat: record.lat, lng: record.lng },
            infoText: `
                        <div style="display:flex;flex-direction:column;font-size:14px;letter-spacing: 0.1em;text-align:center;line-height:1.2rem;color:#292421;font-weight:500">
                            <div style="color:#808a87;display:flex;align-items:center;justify-content:center;gap: 0 3px;">
                                <div style="color:#1890ff;">集合時間</div>
                                <div style="width:16px;height:16px;">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 6V12" stroke="#808a87" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16.24 16.24L12 12" stroke="#808a87" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                </div>
                                <div>${record.gatherAroundDate || '未設定集合時間'}</div>
                            </div>
                            <div style="color:#eb5757;font-size:15px;padding-bottom:6px;padding-top:3px">${record.viewPointName}</div>
                            <div>停留${record.dwellTime}</div>
                            <div>${dayjs(record.startTime, 'HH:mm:ss').format('HH:mm')}~${dayjs(record.leaveTime, 'HH:mm:ss').format('HH:mm')}</div>
                        </div>`,
          }
        })
      } else {
        return []
      }
    },
    computedCenter() {
      if (this.records && this.records.length > 0) {
        return { lat: this.records[0].lat, lng: this.records[0].lng }
      } else {
        return []
      }
    },
  },
  methods: {
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoOptions.content = marker.infoText
      if (this.currentIdx == idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentIdx = idx
      }
    },
  },
}
</script>
